import React from 'react';
import { Translate } from '../../WithTranslate';
import { Button, Classes, Dialog, Intent, Spinner } from '@blueprintjs/core';
import { TLCode } from '../../../../common/enums';

export interface ExclusionDetails {
  date: string;
  dutyType: string;
  pharmacyChecked: string;
  pharmacyWithConflict: string;
  distance: string;
  exclusionDistance: string;
}

export interface ExclusionDetailsDialogProps {
  onClose: () => void;
  detailsToDisplay: ExclusionDetails[];
  translate: Translate;
  isLoading: boolean;
}

export const ExclusionDetailsDialog = ({
  onClose,
  detailsToDisplay,
  translate,
  isLoading,
}: ExclusionDetailsDialogProps) => {
  return (
    <Dialog
      isOpen={detailsToDisplay.length > 0 || isLoading}
      title={translate(TLCode.DUTYASSIGNMENT_Exclusion)}
      canOutsideClickClose={false}
      isCloseButtonShown={false}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className={Classes.DIALOG_BODY}>
            <p>{translate(TLCode.DUTYASSIGNMENT_Exclusion_Explanation)}</p>
            <br />
            <ul>
              {detailsToDisplay.map((dtd) => {
                return (
                  <li>
                    {translate(TLCode.DUTYASSIGNMENT_Exclusion_Detail, {
                      date: dtd.date,
                      dutyType: dtd.dutyType,
                      pharmacyChecked: dtd.pharmacyChecked,
                      pharmacyWithConflict: dtd.pharmacyWithConflict,
                      distance: dtd.distance,
                      exclusionDistance: dtd.exclusionDistance,
                    })}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={onClose} intent={Intent.SUCCESS}>
                {translate(TLCode.Close)}
              </Button>
            </div>
          </div>
        </>
      )}
    </Dialog>
  );
};
